// Client-side mirror of server/services/userIdentity.js STRICT_EMAIL_MATCH
// (2026-07-27 incident: "tugçeustun81@gmail.com" — a non-ASCII ç in the local
// part — passed both the client field and the old server matcher; Gmail local
// parts are ASCII-only, so every mail silently bounced).
//
// Shape enforced, identical to the server rule:
// - local part: ASCII letters/digits and the customary specials . _ % + -,
//   with no leading, trailing, or consecutive dots;
// - domain: dot-separated ASCII alphanumeric/hyphen labels;
// - TLD: alphabetic, length >= 2.
export const STRICT_EMAIL_MATCH = /^[A-Za-z0-9_%+-]+(\.[A-Za-z0-9_%+-]+)*@([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/

export function isValidEmailStrict(value) {
  return typeof value === 'string' && STRICT_EMAIL_MATCH.test(value.trim())
}
